import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface GameEndDialogData {
  gameNumber: number;
  winner: 1 | 2;
  player1Name: string;
  player2Name: string;
  player1Score: number;
  player2Score: number;
  isDarkTheme?: boolean;
}

@Component({
  selector: 'app-game-end-confirmation-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './game-end-confirmation-dialog.component.html',
  styleUrls: ['./game-end-confirmation-dialog.component.scss']
})
export class GameEndConfirmationDialogComponent {
  dialogRef = inject(MatDialogRef<GameEndConfirmationDialogComponent>);
  data = inject<GameEndDialogData>(MAT_DIALOG_DATA);

  get winnerName(): string {
    return this.data.winner === 1 ? this.data.player1Name : this.data.player2Name;
  }

  confirmGameEnd(): void {
    this.dialogRef.close({ confirmed: true });
  }

  undoLastPoint(): void {
    this.dialogRef.close({ confirmed: false, undo: true });
  }
}
